<template>
  <div class="product-introduce">
    <div class="top-banner">
      <div class="top-banner-content">
        <div class="product-name">学位云数据平台</div>
        <div class="product-desc">
          紧密贴合国家学位授权的指标体系，一站式解决学位点申报过程中的数据需求
        </div>
        <a
          href="https://ctadmin.cingta.com/#/degreeform"
          class="bottom-btn"
          target="_black"
          >立即体验</a
        >
      </div>
    </div>
    <div class="base-info-block">
      <div class="base-info-block-container">
        <div class="info-list">
          <div
            class="info-list-item"
            v-for="(info, index) in infoList"
            :key="index"
          >
            <div
              class="item-value"
              :style="{ color: info.color }"
              v-html="info.value"
            ></div>
            <div class="item-label" v-for="label in info.labels" :key="label">
              {{ label }}
            </div>
          </div>
        </div>
        <div class="desc-list">
          <div
            class="desc-list-item"
            v-for="(desc, index) in descList"
            :key="index"
          >
            <div class="item-icon">
              <img
                :src="require(`../../assets/img/product/desc_icon${index}.svg`)"
                alt=""
              />
            </div>
            <div class="item-title">{{ desc.title }}</div>
            <div class="item-content">{{ desc.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="content-block"
      v-for="(content, index) in contentList"
      :key="content.title"
    >
      <product-content-item :content="content" :reverse="!!(index % 2 === 1)" />
    </div>
  </div>
</template>

<script>
import ProductContentItem from "./ProductContentItem.vue";
export default {
  name: "",
  components: { ProductContentItem },
  data() {
    return {
      contentList: [
        {
          title: "了解全国学位点申报整体情况",
          labels: [
            "全国学位点分布：直观呈现全国各省市（区）某一级学科学位点规模和分布情况",
            "学位点获批统计：统计分析近两轮获批硕、博士点的高校数量及省份分布",
            "省际竞争态势分析：量化分析拟申报学位点的省际竞争态势，明确本校学科定位与优势",
          ],
          imgs: [
            require("../../assets/img/product/1.1.jpg"),
            require("../../assets/img/product/1.2.jpg"),
            require("../../assets/img/product/1.3.jpg"),
          ],
        },
        {
          title: "分析本校学位点申报竞争力",
          labels: [
            "基本条件监测：参照《学位授权审核基本条件（2020）》快速筛选未达标指标并呈现目标差距",
            "申报高校监测：对比分析上轮申报高校，展现本校拟申报学位点的相对实力高低",
            "申报指标监测：基于官方指标体系构建评价监测体系，帮助高校实现指标级的精准发力",
          ],
          imgs: [
            require("../../assets/img/product/2.1.jpg"),
            require("../../assets/img/product/2.2.jpg"),
            require("../../assets/img/product/2.3.jpg"),
          ],
        },
        {
          title: "学位点申报模拟分析",
          labels: [
            "学位点申报结果预估：通过高校自主填写的真实数据，与上一轮成功申请的高校数据进行对比分析",
            "科学设定学位点建设目标：量化呈现学科现状与目标值在各维度的差距，助力高校科学设定建设目标",
          ],
          imgs: [
            require("../../assets/img/product/3.1.jpg"),
            require("../../assets/img/product/3.2.jpg"),
          ],
        },
        {
          title: "申报材料案例参考",
          labels: [
            "780+高校申报材料：完整收录上一轮学位点申报，各省市教育主管部门官方网站上公示的高校申请材料",
            "20+分项全面分析：支持从五大维度，20+细分类目对申报高校材料内容进行结构化对照分析",
          ],
          imgs: [
            require("../../assets/img/product/4.1.jpg"),
            require("../../assets/img/product/4.2.jpg"),
          ],
        },
      ],
      descList: [
        {
          title: "研判学位申报竞争态势",
          content:
            "可视化图表直观呈现全国各学位点规模、历年获批情况及区域分布，揭示各学科所面临的竞争压力和发展机遇。",
        },
        {
          title: "洞悉拟申报学位竞争力",
          content:
            "围绕国家学位授权的指标体系构建数据分析模型，全方位展现高校拟申报学位点竞争力，帮助高校实现指标级的精准发力。",
        },
        {
          title: "精细打磨申报材料",
          content:
            "完整收录上轮学位点申报材料，从材料规范到特色凝练，为高校提供完整的案例参照，助力高校厘清申报材料缺漏与不足。",
        },
      ],
      infoList: [
        {
          value: "10,000+",
          labels: ["收录各高校", "申报材料"],
          color: "#2060FF",
        },
        {
          value: "780+",
          labels: ["覆盖全国780所", "学位点申报高校"],
          color: "#FFA944",
        },
        {
          value: "38项",
          labels: ["38项指标评价", "学位点竞争力"],
          color: "#2060FF",
        },
        {
          value: "4类",
          labels: ["服务所有高校", "学位点申报类型"],
          color: "#52C5C4",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleData() {
      this.infoList.forEach((item) => {
        item.value = item.value.replace(/(\d|,)+/g, (key) => {
          return `<span class='ding'>${key}</span>`;
        });
      });
      this.contentList.forEach((content) => {
        content.labels = content.labels.map((label) => {
          const arr = label.split("：");
          return `<span class="bold">${arr[0]}：</span>${arr[1]}`;
        });
      });
    },
  },
  created() {},
  mounted() {
    this.handleData();
  },
};
</script>

<style lang='less'>
.product-introduce {
  color: #141617;
  .top-banner {
    position: relative;
    height: 460px;
    padding-top: 60px;
    background: url("../../assets/img/product/top_banner.jpg") center center /
      cover no-repeat;
    .top-banner-content {
      width: 1180px;
      margin: 0 auto;
      .product-name {
        font-size: 54px;
        font-weight: 600;
        color: #fff;
        line-height: 74px;
        letter-spacing: 6px;
      }
      .product-desc {
        width: 647px;
        margin-top: 22px;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 42px;
        letter-spacing: 5px;
      }
      .bottom-btn {
        cursor: pointer;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        bottom: 80px;
        width: 210px;
        height: 50px;
        font-size: 18px;
        font-weight: 600;
        color: #45bbba;
        line-height: 22px;
        letter-spacing: 1px;
        background: #ffffff;
        border-radius: 3px;
        &:hover {
          opacity: 0.85;
        }
      }
    }
  }
  .base-info-block {
    padding: 90px 0;
    background-color: #f5f6f7;
    &-container {
      width: 1180px;
      margin: 0 auto;
      .info-list {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 170px;
        background: #ffffff;
        box-shadow: 0px 10px 30px 0px rgba(162, 183, 204, 0.1);
        border-radius: 4px;
        &-item {
          text-align: center;
          .item-value {
            margin-bottom: 13px;
            font-size: 38px;
            font-weight: 600;
            line-height: 41px;
          }
          .item-label {
            font-size: 18px;
            color: #656e78;
            line-height: 28px;
            letter-spacing: 1px;
          }
        }
      }
      .desc-list {
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        &-item {
          width: calc((100% - 100px) / 3);
          padding: 40px 40px 46px;
          background: #ffffff;
          box-shadow: 0px 10px 30px 0px rgba(162, 183, 204, 0.1);
          border-radius: 4px;
          .item-icon {
            display: flex;
            justify-content: center;
            > img {
              width: 70px;
            }
          }
          .item-title {
            margin-top: 47px;
            font-size: 26px;
            font-weight: 600;
            color: #141617;
            text-align: center;
            line-height: 34px;
            letter-spacing: 1px;
          }
          .item-content {
            margin-top: 23px;
            font-size: 16px;
            color: #656e78;
            line-height: 30px;
            letter-spacing: 4px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/productInfo/index.vue